export const createWorker = () =>
  new Worker(
    // @ts-ignore
    new URL('./vacations.flow.worker.ts', import.meta.url),
  );
